import React from "react";

// Looping animated explainer. The animation is a self-contained 16:9 "Stage"
// app (auto-plays + loops on its own) shipped as a standalone bundle in
// /public/explainer-anim.html, embedded here via an iframe so its motion
// renders exactly as designed. The player chrome (scrubber/export) is hidden
// inside that file so only the clean looping animation shows.
const Explainer = () => {
  return (
    <section
      id="explainer"
      className="py-24 bg-gradient-to-b from-background to-secondary/20 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-heading font-bold mb-4">
            See Moujib{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              in action
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Watch how Moujib keeps your comment section clean — automatically.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="aspect-video w-full rounded-2xl overflow-hidden border border-border shadow-2xl bg-card">
            <iframe
              src="/explainer-anim.html"
              title="How Moujib works"
              scrolling="no"
              className="w-full h-full block"
              style={{ border: 0 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explainer;
